<template>
  <div id="printable">
    <v-table
      :row-active-id="rowActiveId"
      :data="tableData"
      :columns="columns"
      clickable
      @row-click="onRowClick"
    >
      <template v-slot:column-name="item">
        <span :class="$style.dangerous">
          <dangerous :value="item.row.statusDangerous" />
        </span>
        {{ item.row.name }}
      </template>
    </v-table>
    <additional-list
      v-if="rowActiveId"
      :list="additionalList"
    />
  </div>
</template>

<script>
  import Vue from 'vue';
  import VueToast from 'vue-toast-notification';
  import VTable from '@/components/common/table/table.vue';
  import { dateTime } from '@/helpers/filters';
  import AdditionalList from '@/components/common/logs/additional/list/index.vue';
  import Dangerous from '@/components/common/dangerous/index.vue';
  import { LogData } from '@/domains/log/data';
  import 'vue-toast-notification/dist/theme-default.css';
  import { searchSolr } from '@/api/methods/search';
  import { escapeSpecialSymbols } from '@/utils/escape-symbols';

  Vue.use(VueToast);

  export default {
    components: {
      VTable,
      AdditionalList,
      Dangerous,
    },
    filters: {
      dateTime,
    },
    props: {
      data: {
        type: null,
        required: true,
      },
    },
    data() {
      return {
        columns: [
          {
            field: 'name',
            title: this.$t('pages.columns.filename'),
          },
          { field: 'path', title: this.$t('pages.columns.path') },
          { field: 'size', title: this.$t('pages.columns.size') },
          { field: 'last_modified', title: this.$t('pages.columns.changeTime') },
        ],
        solrText: '',
      };
    },
    computed: {
      rowActiveId() {
        return parseInt(this.$route.params.record, 10);
      },
      tableData() {
        return LogData.filterTable(this.data, ['name', 'path', 'size', 'last_modified'], this.$route.query.filter);
      },
      activeRow() {
        const activeRow = this.data.find((i) => i?.id === this.rowActiveId);
        return activeRow || {};
      },

      additionalList() {
        const row = this.activeRow;

        return [
          ['Имя файла', row.name],
          ['Текст', this.solrText],
        ];
      },
    },
    created() {
      if (this.rowActiveId) {
        this.onRowClick(this.rowActiveId);
      }
      this.$store.commit('logs/printData/setColumns', this.columns);
    },
    methods: {
      async searchSolr() {
        const { activeRow } = this;
        const compId = this.$route.params.computer;
        const validPath = escapeSpecialSymbols(activeRow.path);
        const searchArray = validPath.split(' ');
        const searchQuery =
          `(cid:${compId}) AND ((id_pc_files:[* TO *] AND ((content:(${validPath}))) ` +
          `AND (fname:${activeRow.name})))`;
        const result = await searchSolr(searchQuery, 1, 0, searchArray);
        return result;
      },
      async onRowClick(id) {
        if (this.rowActiveId !== id) {
          this.$router.push({
            name: 'computers-computer-log-record',
            params: { record: id },
            query: this.$route.query,
          });
        }
        this.solrText = 'Загрузка...';

        const result = await this.searchSolr();

        if (result !== 'error') {
          const content = result.solrResult[0]?.content;
          if (content) {
            this.solrText = content;
          } else {
            this.solrText = 'Нет данных';
          }
        }
      },
    },
  };
</script>

<style lang="scss" module>
  .new {
    display: inline-block;
    background: $light-blue;
    color: $blue;
    font-size: 7px;
    padding: 3px;
    margin-right: 8px;
    border-radius: 1px;
  }
  .dangerous {
    display: inline-block;
    margin-right: 8px;
  }
</style>
